export interface EEvidenceApiFailure {
  code: string;
  status: number;
  message: string;
}

const MESSAGE_FOR_CODE: Readonly<Record<string, string>> = {
  InvalidRequest: 'The order could not be accepted. Check the selected PDF and try again.',
  Unauthenticated: 'Your session has expired. Sign in again to continue.',
  Conflict: 'This operation conflicts with an earlier submission or the current case. Check the case before trying again.',
  IntakeUnavailable: 'Submissions are unavailable at this time. Your request was not submitted. Please try again later.',
  InvalidResponse: 'The E-Evidence service returned an unexpected response.',
};

const FALLBACK_MESSAGE = 'Something went wrong. Please try again shortly.';

export function eEvidenceFailure(
  code: string | undefined,
  status: number,
): EEvidenceApiFailure {
  const stableCode = code ?? (status === 0 ? 'TransportFailure' : 'Unknown');
  return {
    code: stableCode,
    status,
    message: MESSAGE_FOR_CODE[stableCode] ?? FALLBACK_MESSAGE,
  };
}

export function isEEvidenceApiFailure(value: unknown): value is EEvidenceApiFailure {
  return (
    typeof value === 'object' &&
    value !== null &&
    'message' in value &&
    typeof (value as EEvidenceApiFailure).message === 'string'
  );
}
